import React, { useCallback, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { StyledTopMenu } from './styles';
import { MenuIcon } from '../../../components/atoms/icons/menu-icon';
import { SideMenu } from '../../../components/organisms/side-menu';
import SingleLogo from '../../../theme/assets/logo/logo-horizontal.webp';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('top-menu');

const TopMenu = () => {
  const navigate = useNavigate();
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false);

  const goToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const openSideMenu = useCallback(() => {
    setIsOpenSideMenu(true);
  }, []);

  const closeSideMenu = useCallback(() => {
    setIsOpenSideMenu(false);
  }, []);

  return (
    <>
      <StyledTopMenu>
        <div className={b()}>
          <div className={b('logo-container')}>
            <img src={SingleLogo} alt="Active Shape" onClick={goToHome} />
          </div>
          <div className={b('menu-container')}>
            <MenuIcon className={b('menu-container', 'menu-button')} onClick={openSideMenu} />
          </div>
        </div>
      </StyledTopMenu>
      <SideMenu isOpen={isOpenSideMenu} onDismiss={closeSideMenu} />
    </>
  );
};

export default TopMenu;
